import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { getRoomTypeCategoriesQuery } from "rsl-api-106/lib/queries";
import { Query, QueryGetRoomTypeCategoriesArgs } from "rsl-api-106/lib/types";

import { useQuery } from "@apollo/client";
import Select from "@components/_Layout/Controls/Select";
import { useSession } from "@hooks";

import { SelectOptionType } from "../../../../../types";

type SearchRoomTypeCategoryProps = {
  etabId: number;
  setRoomCategory: (e: any) => void;
  value: string | null;
};

const languagesVarsCodes = [
  "LANG_neobooking_roomType_choose", //Choisir une formule
  "LANG_neobooking_roomType_loading", //Chargement des formules...
];

const SearchRoomTypeCategory: React.FC<SearchRoomTypeCategoryProps> = ({
  etabId = 1000,
  value,
  setRoomCategory,
}) => {
  const { sessionId, getLanguageVarValue } = useSession();
  const { data, refetch } = useQuery<Query, QueryGetRoomTypeCategoriesArgs>(
    getRoomTypeCategoriesQuery(),
    {
      variables: {
        session: { name: sessionId!! },
        input: {
          propertyId: etabId,
        },
      },
      fetchPolicy: "no-cache",
    }
  );

  /* State */
  const [roomTypeCategoryOptions, setRoomTypeCategoryOptions] = useState<
    SelectOptionType[]
  >([]);

  useEffect(() => {
    if (data && data.getRoomTypeCategories?.roomTypeCategories) {
      const roomTypeCategoriesOptions: SelectOptionType[] =
        data.getRoomTypeCategories.roomTypeCategories.map((r) => {
          return {
            value: r?.label as string,
            label: r?.code as string,
          };
        }) ?? [];

      setRoomTypeCategoryOptions(roomTypeCategoriesOptions);
    }
  }, [data]);

  useEffect(() => {
    refetch();
  }, [etabId]);

  //Au chargement des options, défini la valeur par défaut si la liste.length === 1
  useEffect(() => {
    if (roomTypeCategoryOptions.length === 1) {
      setRoomCategory(roomTypeCategoryOptions[0].value);
    }
  }, [roomTypeCategoryOptions]);

  return (
    <Select
      shape="default"
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
        setRoomCategory(e.target.value)
      }
      options={roomTypeCategoryOptions}
      placeholder={getLanguageVarValue("LANG_neobooking_roomType_choose")}
      loadingPlaceholder={getLanguageVarValue(
        "LANG_neobooking_roomType_loading"
      )}
      additionalClassname="tw-w-full"
      value={value ? value : undefined}
    />
  );
};

SearchRoomTypeCategory.propTypes = {
  etabId: PropTypes.number.isRequired,
};

export default SearchRoomTypeCategory;
